import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {DjPsychoSymbol, DjPsychoSymbolStates} from "../reels/DjPsychoSymbol";

export class DjPsychoExtraFeatureRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (DjPsycho.model.gameData.positionForExtraFeature > -1);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
                delay: 0.1,
                onComplete: () => {
                    controller.finish();
                }
            }),
            positionForExtraFeature: number = DjPsycho.model.gameData.positionForExtraFeature,
            reelId: number = Math.floor(positionForExtraFeature / DjPsycho.reelsNum),
            symId: number = (positionForExtraFeature % DjPsycho.rowsNum);

        tl.add(() => {
            DjPsycho.hotZone.showHotZone(reelId, symId);

            DjPsycho.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                reel.symbols.forEach((symbol: DjPsychoSymbol) => {
                    symbol.setState(DjPsychoSymbolStates.NORMAL);
                });
            });
        });
        tl.to(this, {
            duration: 0.2
        });
    }
}